import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import RetellingCard from './retelling-card/RetellingCard';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { getAuthorFullName, getCurrentYear } from '@/helpers/helpers';
import { IRetelling } from '@/interfaces/retelling.interface';

import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface IRettelingProps {
  books: IRetelling;
}

const Retelling: FC<IRettelingProps> = ({ books }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  const currentPage = books.page;
  const currentYear = getCurrentYear();

  //Seo block
  const SEO_TITLE = `Краткий пересказ книг ${currentYear} — скачать бесплатно или читать онлайн в электронной библиотеке Fantasy Worlds${currentPage > 1 ? `. Cтраница ${currentPage}.` : ``}`;
  const SEO_DESCRIPTION = `Краткий пересказ книг ${currentYear}. ▶ Вы можете скачать бесплатно самые новые книги 📚 в жанре фентези или фантастики в электронной библиотеке Fantasy Worlds.${currentPage > 1 ? ` Cтраница ${currentPage}.` : ``}`;
  const SEO_CANONICAL = '/retelling/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Краткий пересказ" />
      <PageHeading title="Краткий пересказ" />
      <div>
        {books.data &&
          books.data.length > 0 &&
          books.data.map((item) => (
            <RetellingCard
              key={item.book_id}
              description={item.description}
              title={item.title}
              created_at={item.created_at}
              book_alias={item.book_alias}
              external_id={item.external_id}
              rating={item.rating}
              reviews_count={item.reviews_count}
              author_alias={item.author_alias}
              author_name={getAuthorFullName(item.author_first_name, String(item.author_middle_name), item.author_last_name)}
            />
          ))}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`retelling/page=`} />
    </Layout>
  );
};

export default Retelling;
